/* eslint-disable max-len */

import React from 'react';
import { connect } from 'react-redux';

import searchClient from 'bl/client/searchClient.bl';
import { withTranslation } from 'providers/GILT.provider';
import { selectHideDetails } from 'selectors/user';
import fromStringToXs from 'utils/converters/fromStringToXs';
import fromAnyToInitials from 'utils/converters/string/fromAnyToInitials.util';

import ClientItem from 'scheduler/components/ClientItem';

class SearchableDropdown extends React.Component {
  constructor(props) {
    super(props);
    this.state = { searchText: '' };
  }

  componentDidMount() {
    this.focusFirst.focus();
  }

  addNewClient = () => {
    const pathArray = this.props.history.location.pathname.split('/');
    let newPath = this.props.location.pathname;
    if (pathArray[3] === 'day') {
      newPath = pathArray.slice(0, 5).join('/');
    } else if (pathArray[3] === 'week') {
      newPath = pathArray.slice(0, 6).join('/');
    }
    const escapedSearchText = this.state.searchText.replace('/', '');
    if (this.state.searchText.length > 0) {
      this.props.history.push(`${newPath}/appointment/new/create/${escapedSearchText}/client`);
    } else {
      this.props.history.push(`${newPath}/appointment/new/client`);
    }
  };

  pickWalkIn = () => {
    this.props.pickClient('walkIn');
    this.props.history.push('services');
  };

  render() {
    const { type, placeholder, list, pickClient, t } = this.props;
    const resultList = searchClient({ text: this.state.searchText, list });
    const btnStyle = {
      paddingTop: '20px',
      textAlign: 'center',
    };

    return (
      <div className="searchable-container">
        <div className="space">
          <input
            ref={(input) => {
              if (input) {
                this.focusFirst = input;
              }
            }}
            className="input-default search-dropdown"
            type={type}
            placeholder={placeholder}
            value={this.state.searchText.replace(/\s{2,}/g, ' ')}
            onChange={(e) => {
              this.setState({ searchText: e.target.value.toLowerCase() });
            }}
          />
        </div>
        <div style={btnStyle}>
          <div className="btn btn-violet-link f-b text-upper" onClick={this.addNewClient} role="button" tabIndex="0">
            {t('scheduler.booking.addNewClient')}
          </div>
          <div className="btn btn-violet-link f-b text-upper" onClick={this.pickWalkIn} role="button" tabIndex="0">
            {t('scheduler.booking.walkIn')}
          </div>
        </div>
        {this.state.searchText.length >= 2 && (
          <div className="search-dropdown-results find-client in-booking">
            {resultList.length > 0 ? (
              resultList.map((o) => (
                <ClientItem
                  key={o.id}
                  onClick={() => {
                    pickClient(o);
                  }}
                  initials={fromAnyToInitials(o.user_name)}
                  known_as={o.known_as ? o.known_as : ''}
                  phone={o.phone}
                  notes={o.notes ? `notes: ${o.notes}` : ''}
                  rank={o.rank}
                  user_name={o.user_name}
                >
                  {this.props.hideDetails ? <td>{o.phone && fromStringToXs(o.phone)}</td> : <td>{o.phone}</td>}
                </ClientItem>
              ))
            ) : (
              <div />
            )}
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  hideDetails: selectHideDetails(state),
});

const SearchableDropdownHoc = connect(mapStateToProps)(withTranslation()(SearchableDropdown));

export default SearchableDropdownHoc;
